// extracted by mini-css-extract-plugin
module.exports = {"service-availability":"ServiceAvailability_service-availability__Zwgbr","closed":"ServiceAvailability_closed__1U8I8","open":"ServiceAvailability_open__3vOxk"};